import * as type from './constants';

export const setOption = option => ({
  type: type.SET_OPTION,
  option
});